import { FC } from 'react'
import { FormattedMessage } from 'react-intl'
import { Grid } from '@material-ui/core'
import { AddressReverseResult } from 'src/dataSources/dataforsyningen/AddressReverse'
import { virtualBoreholeMetaStyle } from './VirtualBoreholeMeta.style'
import { useSelector } from 'react-redux'
import { RootState } from 'src/Store'

/**
 * VirtualBoreholeMetaProps contains properties for the component.
 */
export interface VirtualBoreholeMetaProps {
  postalAddress?: AddressReverseResult
}

/**
 * VirtualBoreholeMeta displays meta information for virtual boreholes.
 * @param props Properties for component.
 * @returns JSX component.
 */
export const VirtualBoreholeMeta: FC<VirtualBoreholeMetaProps> = (props: VirtualBoreholeMetaProps) => {
  const classes = virtualBoreholeMetaStyle()
  const coords = useSelector((state: RootState): number[] => state.virtualBoreholeInfoState.coordinates)

  return (
    <div className={classes.root}>
      <Grid container>
        <Grid item xs={3}>
          <span className={classes.title}><FormattedMessage id='virtualborehole.info.source' /></span>
        </Grid>
        <Grid item xs={9}>
          Geo<br />
        </Grid>
        <Grid item xs={3}>
          <span className={classes.title}><FormattedMessage id='virtualborehole.info.coordinates' /></span>
        </Grid>
        <Grid item xs={9}>
          {
            coords.length > 1 ? `${coords[0]}, ${coords[1]}` : ''
          }<br />
        </Grid>
        <Grid item xs={3}>
          <span className={classes.title}><FormattedMessage id='virtualborehole.info.address' /></span>
        </Grid>
        <Grid item xs={9}>
          {props.postalAddress?.betegnelse}
        </Grid>
      </Grid>
    </div>
  )
}
